const pretifyName = (name) => {
    return name
        .replace(/[-_.]/g, ' ')
        .replace(/ +/g, ' ')
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
const getColumnLabel = (column) => typeof column === 'object' ? column.label ?? pretifyName(column.key) : pretifyName(column);
const getColumnNames = (columns, items) => columns
    ? columns.map((column) => {
        return typeof column === 'object' ? column.key : column;
    })
    : items && getColumnNamesFromItems(items);
const getColumnNamesFromItems = (items) => Object.keys(items[0] || {}).filter((el) => el.charAt(0) !== '_');

export { getColumnLabel, getColumnNames, getColumnNamesFromItems, pretifyName };
//# sourceMappingURL=utils.js.map
